import { useSelector } from "react-redux";

const CheckRole = ({ children, role }) => {
  const userRole = useSelector((state) => state.userSettings?.user?.userRole);

  return role?.includes(userRole) ? children : null;
};
export default CheckRole;
